<div class="layout-container" [ngClass]="containerClass" *ngIf="loginServices.isValid">
    <app-topbar></app-topbar>
    <app-sidebar></app-sidebar>
    <div class="layout-content-wrapper">
        <div class="layout-content">
            <div class="layout-content-inner">
                <p-messages *ngIf="!loginServices.isValid" severity="warning">
                    <ng-template pTemplate>
                        <div class="ml-2" style="color:var(--red-400)">
                            <h1>No estás autenticado</h1>
                            <i class="pi pi-user" style="color:var(--red-400); font-size: 25px;"></i> &nbsp;
                            <a href="auth/login" style="color: var(--red-400); font-size: 25px;">Iniciar sesión</a>
                        </div>
                    </ng-template>
                </p-messages>
                <router-outlet></router-outlet>
                <app-footer></app-footer>
            </div>
        </div>
    </div>
</div>
<div class="layout-container" [ngClass]="containerClass" *ngIf="!loginServices.isValid">
    <app-topbar></app-topbar>
    <app-sidebar></app-sidebar>
    <div class="layout-content-wrapper">
        <div class="layout-content">
            <div class="layout-content-inner">
                <p-messages severity="warning">
                    <ng-template pTemplate>
                        <div class="ml-2" style="color:var(--red-400)">
                            <h1>No estás autenticado</h1>
                            <i class="pi pi-user" style="color:var(--red-400); font-size: 25px;"></i> &nbsp;
                            <a href="auth/login" style="color: var(--red-400); font-size: 25px;">Iniciar sesión</a>
                        </div>
                    </ng-template>
                </p-messages>
            </div>
        </div>
    </div>
</div>
